import { FC, SVGProps } from "react";
import { IconMap, IconNames } from "@/lib/icon-data";
import { collectShapes, computePathBounds, computeCircleBounds } from "@/lib/svg";

type SocialIconProps = SVGProps<SVGSVGElement> & {
  iconName: IconNames;
  size?: number;
  scale?: number;
};

export const SvgIcon: FC<SocialIconProps> = ({
  iconName,
  size = 28,
  scale = 1,
  ...attrs
}) => {
  const icon = IconMap[iconName as string];
  if (!icon) return null;

  const { paths, circles } = collectShapes(icon);

  if (!paths.length && !circles.length) return null;

  const pathBounds = computePathBounds(paths);
  const circleBounds = computeCircleBounds(circles);

  const minX = Math.min(pathBounds.minX, circleBounds.minX);
  const minY = Math.min(pathBounds.minY, circleBounds.minY);
  const maxX = Math.max(pathBounds.maxX, circleBounds.maxX);
  const maxY = Math.max(pathBounds.maxY, circleBounds.maxY);

  const width = maxX - minX;
  const height = maxY - minY;

  return (
    <svg
      width={size * scale}
      height={size * scale}
      viewBox={`${minX} ${minY} ${width} ${height}`}
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...attrs}
    >
      {icon}
    </svg>
  );
};
